import { RoomState } from '../types/room'

export const initialRoomState: RoomState = {
  currentRoom: null,
  rooms: [],
  charterClasses: [],
  isLoading: false,
  error: null,
  inviteStatus: {
    isLoading: false,
    error: null,
    success: false,
  },
  roomMembers: [],
  dashboardKPIs: {
    total_games: 0,
    scheduled_games: 0,
    active_games: 0,
    completed_games: 0,
    pending_adjudications: 0,
    distinct_players: 0,
    distinct_professors: 0,
    charter_classes: 0,
    charter_class_students: 0,
  },
}
